import { put, call, takeLatest, select } from 'redux-saga/effects';
import API from 'services/api';
import { errorHandler } from 'utils/errorMessages';
import { showSnackbar, setLoading, toggleModal } from 'reducers/ui';
import { getSecurityId } from '../../reducers/users';
import { get } from 'lodash';

import { actions as departmentActions } from 'containers/Pages/People/Departments/Modules/dataGridTable';
import { actions as departmentFilterActions } from 'containers/Pages/People/Departments/Modules/filters';

export function* fetchDepartmentListSaga({ payload }) {
  try {
    const { filters, from } = payload;
    yield put(setLoading(true));
    const securityCompanyId = yield select(getSecurityId);
    const options = {
      securityCompanyId,
      ...filters,
      from,
      archived: get(filters, 'archived', false),
    };
    const { data } = yield call(API.fetchDepartmentList, options);
    if (data.data !== null) {
      const totalEntries = data.meta.total;
      yield put(
        departmentActions.setGridList({
          list: data.data,
          totalEntries,
        }),
      );
    }
    yield put(departmentFilterActions.setFilterKey(false));
    yield put(departmentActions.setForceRefresh(false));
  } catch (error) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(error),
      }),
    );
  }
  yield put(setLoading(false));
}
//
export function* fetchDepartmentByIdSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    const { data } = yield call(API.fetchDepartmentById, {
      id,
    });
    if (data.data) {
      yield put(
        departmentActions.setGridRowDetails({
          details: data.data,
        }),
      );
    }
  } catch (error) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(error),
      }),
    );
  }
  yield put(setLoading(false));
}
//
export function* updateOrCreateDepartmentSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { department } = payload;
    const {
      status,
      data: {
        data: { id },
      },
    } = yield call(API.updateOrCreateDepartment, {
      department,
    });

    if (status === 200) {
      yield put(toggleModal('departments'));
      yield call(fetchDepartmentByIdSaga, { payload: { id } });
    }
  } catch (error) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(error),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* departmentSagas() {
  yield takeLatest(departmentActions.fetchGridList, fetchDepartmentListSaga);
  yield takeLatest(
    departmentActions.fetchGridRowDetails,
    fetchDepartmentByIdSaga,
  );
  yield takeLatest(
    departmentActions.createRowEntry,
    updateOrCreateDepartmentSaga,
  );
  yield takeLatest(
    departmentActions.updateRowEntry,
    updateOrCreateDepartmentSaga,
  );
}
